import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dString$dRegex from "../Data.String.Regex/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dCart$dCart from "../Restaumatic.Cart.Cart/index.js";
import * as Restaumatic$dCart$dDetail from "../Restaumatic.Cart.Detail/index.js";
import * as Restaumatic$dCart$dPromotionalItem from "../Restaumatic.Cart.PromotionalItem/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dPromotions$dTypes$dPromotionalItem from "../Restaumatic.Promotions.Types.PromotionalItem/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dCounter from "../Restaumatic.Site.Components.Cart.Counter/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dCouponInput from "../Restaumatic.Site.Components.Cart.CouponInput/index.js";
import * as Restaumatic$dSite$dComponents$dDialogs$dFOD from "../Restaumatic.Site.Components.Dialogs.FOD/index.js";
import * as Restaumatic$dSite$dHidePhotosExperiment from "../Restaumatic.Site.HidePhotosExperiment/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidgets$dInput from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular$dDom$dWidgets$dSelect from "../Specular.Dom.Widgets.Select/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Utils$dURL from "../Utils.URL/index.js";
const $ProductAvailability = (tag, _1) => ({tag, _1});
const getGlobalLocale = /* #__PURE__ */ Restaumatic$dI18n.getGlobalLocale(Specular$dInternal$dRIO.monadEffectRIO);
const intercalate = sep => xs => Data$dFoldable.foldlArray(v => v1 => {
  if (v.init) { return {init: false, acc: v1}; }
  return {init: false, acc: v.acc + sep + v1};
})({init: true, acc: ""})(xs).acc;
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidArray)(Data$dFoldable.identity))();
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Specular$dInternal$dRIO.applicativeRIO);
const for_1 = /* #__PURE__ */ for_(Data$dFoldable.foldableArray);
const $$null = /* #__PURE__ */ Data$dFoldable.foldrArray(v => v1 => false)(true);
const show1 = /* #__PURE__ */ (() => {
  const $0 = Data$dShow.showArrayImpl(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showSoftError.show);
  return v => {
    if (v.tag === "Just") {
      if (v._1.tag === "Left") { return "(Just (Left " + Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showFatalError.show(v._1._1) + "))"; }
      if (v._1.tag === "Right") { return "(Just (Right " + $0(v._1._1) + "))"; }
      $runtime.fail();
    }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  };
})();
const for_2 = /* #__PURE__ */ for_(Data$dFoldable.foldableMaybe);
const getGlobalLocale1 = /* #__PURE__ */ Restaumatic$dI18n.getGlobalLocale(Effect$dClass.monadEffectEffect);
const monadWidget = /* #__PURE__ */ (() => {
  const $0 = Specular$dDom$dBuilder.monoidBuilder(Data$dMonoid.monoidUnit);
  return {
    MonadDomBuilder0: () => Specular$dDom$dBuilder.monadDomBuilderBuilder,
    MonadFRP1: () => ({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder}),
    MonadReplace2: () => Specular$dDom$dBuilder.monadReplaceBuilder,
    Monoid3: () => $0
  };
})();
const selectInput = /* #__PURE__ */ Specular$dDom$dWidgets$dSelect.selectInput(monadWidget);
const identity = x => x;
const subscribeEvent_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder);
const checkboxView = /* #__PURE__ */ Specular$dDom$dWidgets$dInput.booleanInputView(monadWidget)(Specular$dDom$dWidgets$dInput.Checkbox);
const length = /* #__PURE__ */ Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0);
const NotAvailableNowOrLater = /* #__PURE__ */ $ProductAvailability("NotAvailableNowOrLater");
const AvailableNow = /* #__PURE__ */ $ProductAvailability("AvailableNow");
const AvailableLater = value0 => $ProductAvailability("AvailableLater", value0);
const productImage$p = _theme => item => Restaumatic$dSite$dHidePhotosExperiment.filterProductPhoto((() => {
  if (item.details.tag === "Just") { return Restaumatic$dCart$dDetail.productImage(item.details._1); }
  if (item.details.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
})());
const productErrorsDesc = v => {
  if (v.tag === "Nothing") { return []; }
  if (v.tag === "Just") {
    if (v._1.tag === "Left") {
      if (v._1._1.tag === "TooManyParts") {
        return [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.cart.errors.tooManyParts), {})];
      }
      return [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.cart.errors.productCantBeOrdered), {})];
    }
    if (v._1.tag === "Right") {
      return Data$dFunctor.arrayMap(v1 => {
        if (v1.tag === "ProductNotAvailable") {
          return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.cart.errors.productUnavailable), {});
        }
        if (v1.tag === "ComboNotAvailable") {
          return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.cart.errors.comboUnavailable), {});
        }
        return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.cart.errors.invalidProductVariant), {});
      })(v._1._1);
    }
    $runtime.fail();
  }
  $runtime.fail();
};
const productDetailsView = productAvailability => product => productErrors => Specular$dInternal$dRIO.bindImpl(getGlobalLocale)(locale => {
  const renderWithMultiplicity = v => (v._2 > 1 ? Data$dShow.showIntImpl(v._2) + "x " : "") + Restaumatic$dI18n$dTypes.getLocalization(locale)(v._1);
  return Specular$dInternal$dRIO.bindImpl((() => {
    if (productAvailability.tag === "AvailableLater") {
      return Specular$dDom$dElement.el_("div")(Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.classes(["label", "label-dish", "m-availability__label", "m-availability__label--unavailable"])
      ])(Specular$dDom$dElement.text(productAvailability._1)));
    }
    if (productAvailability.tag === "NotAvailableNowOrLater") {
      return Specular$dDom$dElement.el_("div")(Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.classes(["label", "label-dish", "m-availability__label", "m-availability__label--unavailable"])
      ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.dish_label.unavailable),
        {}
      ))));
    }
    return Specular$dInternal$dRIO.pureImpl();
  })())(() => Specular$dInternal$dRIO.bindImpl((() => {
    if (product.tag === "CustomProductDetails") { return Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("name")])(Specular$dDom$dElement.text(product._1.name)); }
    if (product.tag === "MenuProductDetails") {
      if (product._1.parts.length === 1) {
        const $0 = product._1.customParameters;
        const $1 = product._1.parts[0].customParameters;
        const $2 = product._1.parts[0].modifiers;
        const $3 = product._1.modifiers;
        return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("name")])(Specular$dDom$dElement.text(Restaumatic$dI18n$dTypes.getLocalization(locale)(product._1.parts[0].name))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.el("span")([
          Specular$dDom$dElement.class_("size")
        ])(Specular$dDom$dElement.text(intercalate(", ")(Data$dSemigroup.concatArray(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.choice))(Data$dSemigroup.concatArray($0)($1)))(Data$dFunctor.arrayMap(renderWithMultiplicity)(fold(Data$dFunctor.arrayMap(v => v.addedItems)(Data$dSemigroup.concatArray($3)($2))))))))));
      }
      const $0 = product._1.customParameters;
      const $1 = product._1.modifiers;
      const $2 = product._1.parts;
      return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("name")])(Specular$dDom$dElement.text(intercalate(" / ")(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.name))($2)))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("size")
      ])(Specular$dDom$dElement.text(intercalate(", ")(Data$dSemigroup.concatArray(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.choice))($0))(Data$dFunctor.arrayMap(renderWithMultiplicity)(fold(Data$dFunctor.arrayMap(v => v.addedItems)($1))))))))(() => {
        if ($2.length === 1) {
          const $3 = $2[0].modifiers;
          return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("p")([Specular$dDom$dElement.classes(["m-form__info-text"])])(Specular$dDom$dElement.text(Data$dString$dCommon.joinWith(" / ")(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.choice))($2[0].customParameters)))))(() => for_1($3)(v => Specular$dDom$dElement.el("p")([
            Specular$dDom$dElement.classes(["m-form__info-text"])
          ])(Specular$dDom$dElement.text(Data$dString$dCommon.joinWith(", ")(Data$dFunctor.arrayMap(renderWithMultiplicity)(v.addedItems))))));
        }
        return Specular$dDom$dElement.el("ul")([Specular$dDom$dElement.class_("m-split-pizza-list")])(for_1($2)(v => {
          const $3 = v.customParameters;
          const $4 = v.modifiers;
          return Specular$dDom$dElement.el("li")([Specular$dDom$dElement.class_("m-split-pizza-list__item")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(Restaumatic$dI18n$dTypes.getLocalization(locale)(v.name) + ": "))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("p")([
            Specular$dDom$dElement.classes(["m-form__info-text"])
          ])(Specular$dDom$dElement.text(Data$dString$dCommon.joinWith(" / ")(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.choice))($3)))))(() => for_1($4)(v1 => Specular$dDom$dElement.el("p")([
            Specular$dDom$dElement.classes(["m-form__info-text"])
          ])(Specular$dDom$dElement.text(Data$dString$dCommon.joinWith(", ")(Data$dFunctor.arrayMap(renderWithMultiplicity)(v1.addedItems))))))));
        }));
      })));
    }
    if (product.tag === "MenuComboDetails") {
      return Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("name")])(Specular$dDom$dElement.text(intercalate(" + ")(Data$dFunctor.arrayMap(v => intercalate(" / ")(Data$dFunctor.arrayMap(x => Restaumatic$dI18n$dTypes.getLocalization(locale)(x.name))(v.parts)))(product._1))));
    }
    $runtime.fail();
  })())(() => {
    const productErrorsInfo = productErrorsDesc(productErrors);
    const $0 = $$null(productErrorsInfo);
    const $1 = Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.class_("errors"),
      Specular$dDom$dElement.attr("style")("color: red; display: block;"),
      Specular$dDom$dElement.attr("title")(show1(productErrors))
    ])(Specular$dDom$dElement.text(intercalate(", ")(productErrorsInfo)));
    if (!$0) { return $1; }
    if ($0) { return Specular$dInternal$dRIO.pureImpl(); }
    $runtime.fail();
  }));
});
const productsView = themeSettings => tz => cart => cartAction => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["cart-items", "item"])])(Specular$dDom$dElement.el("ul")([
  Specular$dDom$dElement.class_("list-unstyled")
])(Specular$dInternal$dRIO.bindImpl(getGlobalLocale)(locale => {
  const items = cart.products;
  return Specular$dInternal$dRIO.bindImpl((() => {
    const $0 = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("empty")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("i")([
      Specular$dDom$dElement.class_("icon-shopping-cart")
    ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.empty),
      {}
    ))));
    if (items.length === 0) { return $0; }
    return Specular$dInternal$dRIO.pureImpl();
  })())(() => for_1(items)(productItem => {
    const dishImage = Utils$dURL.adjustImage({w: "60", h: "60", crop: true})((() => {
      const $0 = productImage$p(themeSettings)(productItem);
      if ($0.tag === "Nothing") { return "/uploads/media_library/3759b3df5982ce78756f289321cb79d3.png"; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    })());
    const name = productItem.details.tag === "Just" ? Restaumatic$dCart$dDetail.productName(locale)(productItem.details._1) : "";
    return Specular$dDom$dElement.el("li")([Specular$dDom$dElement.class_("item")])(Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classes(["cart-multi-column", "mobile"])
    ])(Specular$dInternal$dRIO.bindImpl((() => {
      if (
        (() => {
          if (themeSettings.cartDishImages.tag === "Nothing") { return false; }
          if (themeSettings.cartDishImages.tag === "Just") { return themeSettings.cartDishImages._1 === "1"; }
          return false;
        })()
      ) {
        const dishImageStyle = (() => {
          if (themeSettings.dishImageStyle.tag === "Nothing") { return false; }
          if (themeSettings.dishImageStyle.tag === "Just") { return themeSettings.dishImageStyle._1 === "rounded-circle"; }
          return false;
        })()
          ? "u-rounded-circle"
          : "u-border-radius";
        return Specular$dDom$dElement.el("picture")([Specular$dDom$dElement.class_("cart-items__dish-picture")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("source")([
          Specular$dDom$dElement.attr("srcset")("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
          Specular$dDom$dElement.attr("media")("(max-width: 479px)")
        ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.el("img")([
          Specular$dDom$dElement.classes(["cart-items__dish-image", dishImageStyle]),
          Specular$dDom$dElement.attr("src")(Utils$dURL.imgixUrl + dishImage),
          Specular$dDom$dElement.attr("alt")(name)
        ])(Restaumatic$dPrelude$dSpecular.wempty)));
      }
      return Specular$dInternal$dRIO.pureImpl();
    })())(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["column", "info"])])(Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(Data$dDateTime$dInstant.toDateTime)(Effect$dNow.now))(now => {
      const menuProductAvailability = (() => {
        if (productItem.details.tag === "Just") {
          if (productItem.details._1.tag === "MenuProductDetails") {
            return Data$dArray.indexImpl(
              Data$dMaybe.Just,
              Data$dMaybe.Nothing,
              Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(v1 => v1.availability)(productItem.details._1._1.parts)),
              0
            );
          }
          return Data$dMaybe.Nothing;
        }
        return Data$dMaybe.Nothing;
      })();
      const $0 = Data$dTime$dLocal.utcToLocalDateTime(now)(tz);
      if (menuProductAvailability.tag === "Just") {
        const productAvailability = (() => {
          if (Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(menuProductAvailability._1)($0).tag === "NotAvailableAtTheTime") {
            return $ProductAvailability(
              "AvailableLater",
              Restaumatic$dCalendar$dTypes$dAvailability.formatDailyAvailability(Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(menuProductAvailability._1)($0)._1)
            );
          }
          if (Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(menuProductAvailability._1)($0).tag === "NotAvailableWholeDay") { return NotAvailableNowOrLater; }
          return AvailableNow;
        })();
        return for_2(productItem.details)(productDetails => productDetailsView(productAvailability)(productDetails)(productItem.errors));
      }
      return for_2(productItem.details)(productDetails => productDetailsView(AvailableNow)(productDetails)(productItem.errors));
    })))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["column", "subtotal"])])(Specular$dInternal$dRIO.bindImpl((() => {
      const $0 = Specular$dDom$dElement.el("strong")([Specular$dDom$dElement.classes(["item__price"])])(for_2(productItem.unitPrice.tag === "Just"
        ? Data$dMaybe.$Maybe("Just", productItem.quantity * productItem.unitPrice._1 | 0)
        : Data$dMaybe.Nothing)(x => Specular$dDom$dElement.text(Restaumatic$dSite$dI18n.currency(x))));
      if (
        (() => {
          if (productItem.errors.tag === "Nothing") { return true; }
          if (productItem.errors.tag === "Just") {
            if (productItem.errors._1.tag === "Right") { return productItem.errors._1._1.length === 0; }
            return false;
          }
          return false;
        })()
      ) {
        return $0;
      }
      return Specular$dInternal$dRIO.pureImpl();
    })())(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["item__quantity"])])(Restaumatic$dSite$dComponents$dCart$dCounter.counterView(productItem.quantity)(q => cartAction(Restaumatic$dCart$dCart.$Action(
      "ModifyQuantity",
      {key: productItem.key, note: productItem.note},
      v => q
    ))))))))));
  }));
})));
const descriptionView = translatedDescription => Specular$dInternal$dRIO.bindImpl(getGlobalLocale1)(locale => {
  const description = Restaumatic$dI18n$dTypes.getLocalization(locale)(translatedDescription);
  const $0 = Data$dString$dRegex.regex("[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)")({
    global: true,
    ignoreCase: true,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
  });
  if ($0.tag === "Left") { return Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("description")])(Specular$dDom$dElement.text(description)); }
  if ($0.tag === "Right") {
    const $1 = Data$dString$dRegex.match($0._1)(description);
    if ($1.tag === "Just") {
      const descriptionWithoutUrl = Data$dString$dRegex.replace($0._1)("")(description);
      const $2 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, $1._1, 0);
      const $3 = (() => {
        if ($2.tag === "Just") { return $2._1; }
        $runtime.fail();
      })();
      if ($3.tag === "Just") {
        const $4 = $3._1;
        return Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("description")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(descriptionWithoutUrl))(() => Specular$dDom$dElement.el("a")([
          Specular$dDom$dElement.class_("description"),
          Specular$dDom$dElement.attr("target")("_blank"),
          Specular$dDom$dElement.attr("href")($4)
        ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.cart.promotions.showMore),
          {}
        )))));
      }
      if ($3.tag === "Nothing") { return Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("description")])(Specular$dDom$dElement.text(description)); }
      $runtime.fail();
    }
    if ($1.tag === "Nothing") { return Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("description")])(Specular$dDom$dElement.text(description)); }
    $runtime.fail();
  }
  $runtime.fail();
});
const promotionDetailsView = details => input => changeInput => Specular$dInternal$dRIO.bindImpl(getGlobalLocale1)(locale => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.class_("name")
])(Specular$dDom$dElement.text(Restaumatic$dI18n$dTypes.getLocalization(locale)(details.name))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => {
  if (details.inputOptions.tag === "FreeProductInputOptions") {
    const $0 = details.inputOptions._1.choices;
    return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("description")])(Specular$dDom$dElement.text(Restaumatic$dI18n$dTypes.getLocalization(locale)(details.description))))(() => Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classes(["m-select", "m-select--inline"])
    ])(Specular$dInternal$dRIO.bindImpl(selectInput({
      options: $0,
      initialValueIndex: (() => {
        const $1 = Data$dArray.findIndexImpl(
          Data$dMaybe.Just,
          Data$dMaybe.Nothing,
          x => {
            if (input.tag === "FreeProductInput") { return input._1.selection === x; }
            return false;
          },
          $0
        );
        if ($1.tag === "Nothing") { return 0; }
        if ($1.tag === "Just") { return $1._1; }
        $runtime.fail();
      })(),
      display: identity,
      attributes: Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure((() => {
        const $1 = {};
        $1.class = "m-select__select promotion-select";
        return $1;
      })())
    }))(value => subscribeEvent_(x => changeInput(Restaumatic$dPromotions$dTypes$dPromotionalItem.$PromotionalItemInput("FreeProductInput", {selection: x})))(value))));
  }
  if (details.inputOptions.tag === "CouponCodeInputOptions") { return Restaumatic$dPrelude$dSpecular.wempty; }
  if (details.inputOptions.tag === "NoInputOptions") { return descriptionView(details.description); }
  $runtime.fail();
})));
const promotionItemView = extraClass => cartAction => item => {
  const isSelected = item.engineItem.selection.tag === "UserEnabled" || item.engineItem.selection.tag === "AutoEnabled";
  const isActive = item.engineItem.active;
  return Specular$dDom$dElement.el("li")([
    Specular$dDom$dElement.classes(["item", "promotion"]),
    isSelected ? Specular$dDom$dElement.monoidProp.mempty : Specular$dDom$dElement.class_("off"),
    isActive ? Specular$dDom$dElement.monoidProp.mempty : Specular$dDom$dElement.class_("item--inactive"),
    (() => {
      if (extraClass.tag === "Just") { return Specular$dDom$dElement.class_(extraClass._1); }
      if (extraClass.tag === "Nothing") { return Specular$dDom$dElement.monoidProp.mempty; }
      $runtime.fail();
    })()
  ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["cart-multi-column", "mobile"])])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["column", "info"])
  ])(promotionDetailsView(item.details)(item.engineItem.input)((() => {
    const $0 = Restaumatic$dCart$dCart.ChangePromotionalItemInput(item);
    return x => cartAction($0(x));
  })())))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["column", "column--checkbox"])])(Specular$dDom$dElement.el("label")([
    Specular$dDom$dElement.classes(["m-checkbox", "m-checkbox--center"]),
    isActive ? Specular$dDom$dElement.monoidProp.mempty : Specular$dDom$dElement.class_("invisible")
  ])(Specular$dInternal$dRIO.bindImpl(checkboxView(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(isSelected))(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $0 = {};
    $0.class = "promotion-enabled m-checkbox__input";
    return $0;
  })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $0 = (() => {
      const $0 = {};
      $0.disabled = "disabled";
      return $0;
    })();
    if (isActive) { return Foreign$dObject.empty; }
    return $0;
  })())((() => {
    const $0 = "Cart/promotions/" + Data$dShow.showIntImpl(item.engineItem.promotion.promotionId) + "/toggle";
    return (() => {
      const $1 = {};
      $1["data-testid"] = $0;
      return $1;
    })();
  })())))))(setSelectedE => Specular$dInternal$dRIO.bindImpl(subscribeEvent_((() => {
    const $0 = Restaumatic$dCart$dCart.SetPromotionalItemSelected(item);
    return x => cartAction($0(x));
  })())(setSelectedE))(() => Specular$dDom$dElement.el("i")([Specular$dDom$dElement.class_("m-checkbox__icon-state")])(Restaumatic$dPrelude$dSpecular.wempty))))))(() => Specular$dDom$dElement.el("strong")([
    Specular$dDom$dElement.classes(["item__price", "item__price--promotion"]),
    isActive ? Specular$dDom$dElement.monoidProp.mempty : Specular$dDom$dElement.class_("invisible")
  ])(Specular$dDom$dElement.text(Restaumatic$dSite$dI18n.currency((() => {
    if (item.engineItem.selection.tag === "UserEnabled" || item.engineItem.selection.tag === "AutoEnabled") {
      if (item.engineItem.value.tag === "Nothing") { return 0; }
      if (item.engineItem.value.tag === "Just") { return item.engineItem.value._1; }
      $runtime.fail();
    }
    return 0;
  })())))))));
};
const promotionsView = cart => fodCfg => enableCoupons => cartAction => promotionsChanged => {
  const noCouponItemView = Specular$dDom$dElement.el("li")([Specular$dDom$dElement.classes(["item", "promotion", "item--group"])])(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["cart-multi-column", "mobile"])
  ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["column", "info"])])(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["alert", "alert-warning"])
  ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.no_coupon_items),
    {}
  ))))));
  const v = Data$dArray.partitionImpl(Restaumatic$dCart$dPromotionalItem.promotionalItemCouponPromotion, cart.promotionalItems);
  const $0 = v.yes;
  const $1 = v.no;
  const $2 = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["m-cart-promotions", "item"])])(Specular$dDom$dElement.el("ul")([
    Specular$dDom$dElement.class_("u-list-unstyled")
  ])(Specular$dInternal$dRIO.bindImpl((() => {
    const $2 = fodCfg.fodEnabled ? Restaumatic$dSite$dComponents$dDialogs$dFOD.wizardWidget(fodCfg) : Specular$dInternal$dRIO.pureImpl();
    return env => {
      const $3 = {...env, userEnv: undefined};
      return $2($3);
    };
  })())(() => Specular$dInternal$dRIO.bindImpl(for_1($1)(promotionItemView(Data$dMaybe.Nothing)(cartAction)))(() => {
    const $2 = Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dCart$dCouponInput.couponInputWidget(cart)(promotionsChanged))(() => Specular$dInternal$dRIO.bindImpl((() => {
      if (cart.couponCode.tag === "Nothing") { return false; }
      if (cart.couponCode.tag === "Just") { return true; }
      $runtime.fail();
    })() && length($0) === 0
      ? noCouponItemView
      : Specular$dInternal$dRIO.pureImpl())(() => for_1($0)(promotionItemView(Data$dMaybe.$Maybe("Just", "item--group"))(cartAction))));
    if (enableCoupons) { return $2; }
    return Specular$dInternal$dRIO.pureImpl();
  }))));
  if (enableCoupons || fodCfg.fodEnabled || !$$null($1)) { return $2; }
  return Specular$dInternal$dRIO.pureImpl();
};
const itemsView = fodCfg => enableCoupons => themeSettings => tz => cart => cartAction => promotionsChanged => Specular$dInternal$dRIO.bindImpl(env => {
  const $0 = {...env, userEnv: undefined};
  return productsView(themeSettings)(tz)(cart)(cartAction)($0);
})(() => promotionsView(cart)(fodCfg)(enableCoupons)(cartAction)(promotionsChanged));
export {
  $ProductAvailability,
  AvailableLater,
  AvailableNow,
  NotAvailableNowOrLater,
  checkboxView,
  descriptionView,
  fold,
  for_,
  for_1,
  for_2,
  getGlobalLocale,
  getGlobalLocale1,
  identity,
  intercalate,
  itemsView,
  length,
  monadWidget,
  $$null as null,
  productDetailsView,
  productErrorsDesc,
  productImage$p,
  productsView,
  promotionDetailsView,
  promotionItemView,
  promotionsView,
  selectInput,
  show1,
  subscribeEvent_
};
